module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image0",
    attrs: {
      "id": "ch-4"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/21-1.jpg"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "chapter-no"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/d4.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('h1', {
    staticClass: "chapter-title-gr"
  }, [_vm._v("The Rough In")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph"
  }, [_c('em', [_vm._v("But understand this: If the owner of the house had known at what time of night the thief was coming, he would have kept watch and would not have let his house be broken into.")])]), _vm._v(" "), _c('p', {
    staticClass: "epigraph-author"
  }, [_vm._v("M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ATTHEW")]), _vm._v(" 24:43")]), _vm._v(" "), _c('p', {
    staticClass: "line-image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/line2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "d-para"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_c('span', {
    staticClass: "brwn"
  }, [_vm._v("I")])]), _vm._v("n construction, specifically plumbing, electrical, and HVAC (heating, ventilation, and air-conditioning), the initial stage is called the rough in. If you have never walked through a home in this state, I’ll tell you that it looks like a framed house with wires, pipes, and ductwork poking through the wooden studs. It is progress on the project, but it isn’t much to look at.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Here I am among a heap of wood, concrete, and gadgets that don’t interest me. Who just wants to fluff pillows?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/21-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I’m not lazy; I’m just not a mechanical kind of gal. I want to pick paint colors and stew over fabric swatches. However, we all know you have to plug in the lamp before you turn it on, and that plug better be hooked up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("But as pedestrian as they are, the rough-in stage technicalities are necessary to build the rest of the home. And that goes for building a stress-free life too.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("In order to depend on your faith, you best know what the details and facts are.")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("With our conscious minds, we profess our belief in the fact that Jesus died on the cross to pay for the things we’ve done wrong. We say that we believe we are free from the consequences of our sinful choices. However, what’s going on behind the scenes? Back behind the Sheetrock, what do you "), _c('em', [_vm._v("really")]), _vm._v(" believe? Do you know? You may answer, “I believe God is good and Jesus died for my sins.” But is your heart-head (the machine that not only reminds you to breathe, eat, and yawn but also registers stress) in agreement with the words of your mouth?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/22-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("If with your mouth you profess, “God is good. He will help me,” but your heart-head is humming behind the Sheet-rock, “God didn’t help you get that promotion or heal your brother-in-law’s cancer,” that thought is your "), _c('em', [_vm._v("real")]), _vm._v(" belief.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Your subconscious doesn’t miss a thing. The subconscious saw an alarming TikTok that combats your belief about God and what you thought you knew for sure. Then the subconscious mind, with its easily swayed convictions and feel-good-now demands, created a genius image tearing down your faith and trust in God.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The bad news is the heart-head can’t tell the difference between perceived threats and real ones. So that horrifying news clip you watch from the safe comfort of your living room? Your heart-head thinks you are there scaling walls, begging for escape. With your conscious mind you are sitting, watching television to unwind. Meanwhile, your heart-head is screaming, “Get up and run, dummy!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Simultaneously, the subconscious releases the hormone hounds of real panic—adrenaline and cortisol. Who knew after an early morning, a quick stint at the gym, a Zoom call, an angry coworker, grocery shopping, traffic, dinner, bath time, story time, and cleaning up after the dog, you would now also have to battle the Taliban!")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/22-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("You don’t, really. That’s the good news.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("The even better news is that you don’t have to pay attention to the TikTok dissing God either.")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Instead we can choose to look at the mess, disaster, or malady and say or write out what we know to be true and then choose to feel safe, protected, and loved. We can recognize that the wires are crossed and the plumbing is backing up in the sink simply because we didn’t know to prepare. But now that we know where the threat is coming from, we can plug in the power of truth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Today I invite you to stop and identify your feelings in any given instance, and then tell the heart-head what you know and need it to understand. This practice retrains the mind to know the difference between an actual leak behind the fridge and a runaway ice cube that has melted on the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("If, like me, you know a lot of Scripture, what Scripture verses come to mind when you stop and identify the feeling and then apply a scriptural promise to the emotion? Can’t think of one? Go use the internet for something good and search for Scripture verses about God’s love and security. This is a practice in activating the subconscious in the discovery of your why. Why do you believe something? How is it serving your peace? And what does Jesus have to say about it? When we get the practice of looking for truth down, it becomes an epic part of a real belief, which equates to living stress-free.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Lucky you! Plug that lamp into the true power source.")]), _vm._v(" "), _c('div', {
    staticClass: "box-o"
  }, [_c('h1', {
    staticClass: "box-title"
  }, [_c('strong', [_vm._v("THE FINISHING TOUCH")])]), _vm._v(" "), _c('p', {
    staticClass: "box-para"
  }, [_vm._v("Lord, open my mind to the endless goodness I have doubted. Help me look beyond the mess and see what you see. Amen.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75894980","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/011_Chapter04.vue
// module id = 87
// module chunks = 0